import React, { useContext } from "react";
import faqPageLoginStyle from "../../assets/jss/xrs/views/faqPageLoginStyle";
import { makeStyles } from "tss-react/mui";
import HeaderSectionLoggedID from "../SectionsPage/Sections/HeaderSectionLoggedID.js";
import FaqSection from "../SectionsPage/Sections/FaqSection.js";
import Context from "../../utils/context";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import { primaryColor } from "assets/jss/xrs.js";
import { Box } from "@mui/material";
const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;

let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}
const useStyles2 = makeStyles()((theme) => faqPageLoginStyle(theme));

export default function FaqPageLogin() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const context = useContext(Context);

  const { classes: classes2, cx } = useStyles2();

  return (
    <Box component="div" sx={{ backgroundColor: primaryColor[14] }}>
      <HeaderSectionLoggedID
        page="Faq"
        title="Frequently Asked Questions"
      ></HeaderSectionLoggedID>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <main
            className={cx(classes2.content, {
              [classes2.contentShift]: context.stateDrawer,
            })}
          >
            <FaqSection></FaqSection>
          </main>
        </GridItem>
      </GridContainer>
    </Box>
  );
}
